module.exports = __webpack_public_path__ + "static/media/antic-home-2.370c0242.jpg";